import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    attendanceManagementColumns: {}
};

const columnSettingsSlice = createSlice({
    name: 'columnSettings',
    initialState,
    reducers: {
        setAttendanceManagementColumns: (state, action) => {
            const { userId, companyNo, columns } = action.payload;
            const key = `${userId}_${companyNo}`;
            state.attendanceManagementColumns[key] = columns;
        },
        clearAttendanceManagementColumns: (state, action) => {
            const { userId, companyNo } = action.payload;
            const key = `${userId}_${companyNo}`;
            delete state.attendanceManagementColumns[key];
        }
    }
});

export const { setAttendanceManagementColumns, clearAttendanceManagementColumns } = columnSettingsSlice.actions;
export default columnSettingsSlice.reducer; 